<template>
  <div>
    <div class="right-title">
      <span>简历详情</span>
      <el-button plain class="go-back" @click="goBack" v-if="historyNum>2">返回</el-button>
    </div>
    <div class="content-box" v-if="isLoading">
      <div style="width: 900px;margin: 0 auto;">
        <div class="box1">
          <div class="left">
            <img :src="headimg" alt="">
          </div>
          <div class="right">
            <h1>{{user.user_real_name}}</h1>
            <p>
              {{user.sex | sex}} <span>|</span>{{user.birthday | birthday}}<span>|</span>{{user.address_name | address}}
            </p>
            <div>
              <span><i class="iconfont icondianhua"></i>{{user.phone}}</span>
              <span><i class="iconfont iconweibiaoti554"></i>{{user.email}}</span>
            </div>
          </div>
        </div>

        <div class="box2" v-if="data.resume.holp_work_site">
          <h2 class="title">职业发展意向</h2>
          <div class="list">
            <div>
              <span>期望地点:</span>{{data.resume.holp_work_site}}
            </div>
            <div>
              <span>期望领域:</span>{{data.resume.holp_field}}
            </div>
            <div>
              <span>期望年薪:</span>{{data.resume.holp_salary}}
            </div>

          </div>
        </div>
        <div class="box2" v-if="data.workHistory.length>0">
          <h2 class="title">工作经历</h2>
          <div class="items" v-for="(item,index) in data.workHistory" :key="index">
            <div class="left-icon">
              <i></i>
            </div>
            <div class="left-shu" v-if="(index+1) !== data.workHistory.length"></div>
            <div class="time">{{item.start_time | time}} - {{item.end_time | time}}</div>
            <div class="list">
              <div style="width: 100%">
                {{item.organization_name}}
              </div>
              <div>
                <span>机构类型:</span>{{item.origanization_type_cn}}
              </div>
              <div>
                <span>所在地区:</span>{{item.district_cn}}
              </div>
              <div>
                <span>机构规模:</span>{{item.scale_cn}}
              </div>
              <div>
                <span>所属领域:</span>{{item.industry_cn}}
              </div>
              <div>
                <span>所在部门:</span>{{item.branch_cn}}
              </div>
              <div>
                <span>职位:</span>{{item.jobs_name}}
              </div>
              <div>
                <span>下属人数:</span>{{item.underling}}
              </div>
              <div>
                <span>汇报对象:</span>{{item.report_obj_cn}}
              </div>
              <div>
                <span>税前月薪:</span>{{item.nian_xin}}元
              </div>
              <div style="width: 100%">
                <span>离职原因:</span>{{item.leave_offer}}
              </div>
              <div style="width: 100%">
                <span>工作职责和业绩:</span>{{item.job_duty}}
              </div>
              <div style="width: 100%">
                <span>机构描述:</span>{{item.organization_detail}}
              </div>
            </div>
          </div>
        </div>
        <div class="box2" v-if="data.projectHsitory.length>0">
          <h2 class="title">项目经历</h2>
          <div class="items" v-for="(item,index) in data.projectHsitory" :key="index">
            <div class="left-icon">
              <i></i>
            </div>
            <div class="left-shu" v-if="(index+1) !== data.projectHsitory.length"></div>
            <div class="time">{{item.start_time | time}} - {{item.end_time | time}}</div>
            <div class="list">
              <div style="width: 100%">
                {{item.title}}
              </div>
              <div style="width: 100%">
                <span>项目描述:</span>{{item.content}}
              </div>
            </div>
          </div>
        </div>
        <div class="box2" v-if="data.educationHsitory.length>0">
          <h2 class="title">教育经历</h2>
          <div class="items items2" v-for="(item,index) in data.educationHsitory" :key="index">
            <div class="left-icon">
              <i></i>
            </div>
            <div class="left-shu" v-if="(index+1) !== data.educationHsitory.length"></div>
            <div class="list">
              <div style="width: 100%">
                <span>{{item.school}}</span>
                <span>{{item.education_cn}}</span>
                <span>{{item.speciality}}</span>
                <span>{{item.is_tong === 0?'非统招':'统招'}}</span>
                <span class="times">{{item.start_time | time}} - {{item.end_time | time}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="box2" v-if="data.resume.english_hear !== 0">
          <h2 class="title">语言能力</h2>
          <div class="list">
            <div style="width: 100%">
              <span>英语:</span> 听<b>{{data.resume.english_hear | lang}}</b>说<b>{{data.resume.english_speak |
                lang}}</b>读<b>{{data.resume.english_read
                | lang}}</b>写<b>{{data.resume.english_write | lang}}</b>
            </div>
            <div style="width: 100%">
              <span>中文:</span> 沟通能力 <b>{{data.resume.chinese_speak | lang}}</b> 写作能力 <b>{{data.resume.chinese_write |
                lang}}</b>
            </div>
            <div v-for="(item, index) in data.resume.other_language" :key="index">
              <span>{{item.name}}:</span>{{item.option}}
            </div>
          </div>
        </div>
        <div class="box2" v-if="data.resume.img_ids.length>0">
          <h2 class="title">相关证书</h2>
          <div class="list">
            <div style="width: 100%;flex-wrap: wrap;">
              <b v-for="(item,index) in data.resume.img_ids" :key="index">{{item}}</b>
            </div>
          </div>
        </div>
        <div class="box2" v-if="data.resume.lable_ids.length>0">
          <h2 class="title">专业技能</h2>
          <div class="list">
            <div style="width: 100%;flex-wrap: wrap;">
              <b v-for="(item,index) in data.resume.lable_ids" :key="index">{{item}}</b>
            </div>
          </div>
        </div>
        <div class="box2" v-if="data.resume.accessory_name">
          <h2 class="title">附件简历</h2>
          <div class="list">
            <div style="width: 100%;">
              <a :href="data.resume.accessory_path" style="color: #00a2ea;" target="_blank">{{data.resume.accessory_name}}</a>
            </div>
          </div>
        </div>
        <div class="box2" v-if="data.resume.file_url">
          <h2 class="title">附件简历</h2>
          <div class="list">
            <div style="width: 100%;">
              <a :href="data.resume.file_url" style="color: #00a2ea;" target="_blank">{{data.resume.title}}</a>
            </div>
          </div>
        </div>
        <div class="box2" v-if="data.resume.self_eval">
          <h2 class="title">自我评价</h2>
          <div class="list">
            <div style="width: 100%;flex-wrap: wrap;">
              <b>{{data.resume.self_eval}}</b>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footerBox class="footer"/>

  </div>
</template>

<script>
import footerBox from '../components/rightBottom'
import config from '../../../../config/index'

export default {
  name: "hxrResume",
  data() {
    return {
      addLabel: '',      //  标签名称
      headimg: '',      //  头像
      data: {},         //  简历数据
      user: {},          //  候选人信息
      isShenhe: false,    //  是否显示审核
      biaoqianShade: false, //  标签显示
      lableList: [],         //  标签集合
      baogaoShade: false, //  标签显示
      baogaoList: [],         //  标签集合
      msTitle: '',         //  面试报告右侧标题
      msContent: '',       //  面试报告右侧内容
      msIndex: 0,         //  面试报告左侧选择下标
      isLoading: false,
      historyNum:0
    }
  },
  computed: {
    userinfo() {
      return this.$store.state.user
    }
  },
  created() {
    if (this.$route.query.shenhe) {
      this.isShenhe = true
    }
    // this.$emit('setType', 0)
    // 获取简历数据
    this.init()
    this.getLanel()
    this.historyNum = history.length
  },
  methods: {
    async init() {
      const loading = this.$loading({
        target: this.$refs.container,
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.7)'
      });
      let res = await this.$api.apiContent.detailResume({
        admin_id: this.userinfo.id,
        resumeId: this.$route.params.id,
      })
      let data = res.data
      data.resume.other_language = !data.resume.other_language ? [] : JSON.parse(data.resume.other_language)
      data.resume.img_ids = !data.resume.img_ids ? [] : data.resume.img_ids.split(',')
      data.resume.lable_ids = !data.resume.lable_ids ? [] : data.resume.lable_ids.split(',')
      // data.resume.accessory_path = config.urlStr + '/' + data.resume.accessory_path
      // data.resume.file_url = config.urlStr + '/' + data.resume.file_url

      data.resume.accessory_path = config.downUrlStr + '?urlFile='+ data.resume.accessory_path + '&userToken='+ this.$route.query.resumeId
      data.resume.file_url = config.downUrlStr + '?urlFile='+ data.resume.file_url + '&userToken='+ this.$route.query.resumeId

      data.resume.type = config.urlStr + '/' + data.resume.type
      this.data = data
      this.user = data.userinfo
      this.baogaoList = data.Msbg
      this.headimg = config.urlStr + '/' + data.userinfo.headimg
      if (this.baogaoList.length > 0) {
        this.msContent = this.baogaoList[0].content
        this.msTitle = this.baogaoList[0].title
      }
      loading.close();
      this.isLoading = true
    },
    addLabelClick() {
      if (!this.addLabel) {
        this.$message.error('请填写标签')
        return
      }
      this.$api.apiContent.addLabel({
        reid: this.$route.query.resumeId,         //简历id
        name:this.addLabel,         // 添加标签名称
        admin_id:this.userinfo.id,
      }).then(() => {
        this.addLabel = ''
        this.getLanel()
      }).catch(e => {
        this.$message.error(e.info)
      })
    },
    //  简历审核
    shenhe(state) {      //  1 通过 2 拒绝
      if(state === 1){
        this.$confirm('您确定要审核通过吗', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          this.$api.apiContent.shenheResume({
            admin_id: this.userinfo.id,
            resumeId: this.$route.query.resumeId,
            audit: state
          }).then(() => {
            this.$message.success('审核完成')
            this.goBack()
          }).catch(e => {
            this.$message.error(e.info)
          })
        }).catch()
      }else {
        this.$prompt('请填写拒绝理由', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(({value}) => {

          this.$api.apiContent.shenheResume({
            admin_id: this.userinfo.id,
            resumeId: this.$route.query.resumeId,
            audit: state,
            delContent:value
          }).then(() => {
            this.$message.success('审核完成')
            this.goBack()
          }).catch(e => {
            this.$message.error(e.info)
          })
        }).catch();
      }





      // let _str = state === 1 ? '您确定要审核通过吗？' : '您确定要拒绝吗？'
      // this.$confirm(_str, '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // }).then(() => {
      //   this.$api.apiContent.shenheResume({
      //     admin_id: this.userinfo.id,
      //     resumeId: this.$route.query.resumeId,
      //     audit: state
      //   }).then(() => {
      //     this.$message.success('审核完成')
      //     this.goBack()
      //   }).catch(e => {
      //     this.$message.error(e.info)
      //   })
      // }).catch()
    },
    //  切换面试报告
    tabMs(index) {
      this.msIndex = index
      this.msContent = this.baogaoList[index].content
      this.msTitle = this.baogaoList[index].title
    },
    //  删除标签
    deleteLabel(id) {
      this.$confirm('您确定要删除次标签吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api.apiContent.deleteLabel({
          admin_id: this.userinfo.id,
          reid: this.$route.query.resumeId,
          tag_id: id
        }).then(() => {
          this.getLanel()
        }).catch(e => {
          this.$message.error(e.info)
        })
      }).catch(() => {

      })
    },
    //  显示标签
    showLabel() {
      // if (this.lableList.length > 0) {
      this.biaoqianShade = true
      // } else {
      //   this.biaoqianShade = false
      //   this.$message.error('暂无标签')
      // }
    },
    //  显示面试报告
    showBaogao() {
      if (this.baogaoList.length > 0) {
        this.baogaoShade = true
      } else {
        this.baogaoShade = false
        this.$message.error('暂无面试报告')
      }
    },
    //  获取标签
    getLanel() {
      this.$api.apiContent.resumeLabelList({
        admin_id: this.userinfo.id,
        reid: this.$route.query.resumeId,
      }).then(res => {
        this.lableList = res.data
      }).catch(() => {
        this.lableList = []
      })
    },
    goBack() {     //  返回上一页
      this.$tools.goBack()
    },
  },
  watch: {},
  filters: {
    //  听说读写
    lang(val) {
      let num = Number(val)
      if (num === 1) {
        return '精通'
      }
      if (num === 2) {
        return '良好'
      }
      if (num === 3) {
        return '一般'
      }
      if (num === 4) {
        return '不具备'
      }
    },
    //  时间转化
    time(val) {
      let num = Number(val)
      if (num === 0) {
        return '至今'
      } else {
        let date1 = new Date(num * 1000)
        let _dates = date1.getFullYear() + "." + ((date1.getMonth() + 1) < 10 ? "0" + (date1.getMonth() + 1) : (date1.getMonth() + 1)) + "." + (date1.getDate() < 10 ? "0" + date1.getDate() : date1.getDate())
        return _dates
      }
    },
    type(val) {
      // 1全职 2实习 3兼职 4短期
      let num = Number(val)
      if (num === 1) {
        return '全职'
      }
      if (num === 2) {
        return '实习'
      }
      if (num === 3) {
        return '兼职'
      }
      if (num === 4) {
        return '短期'
      }
    },
    // 转化性别
    sex(val) {
      if (Number(val) === 1) {
        return '男'
      } else if (Number(val) === 2) {
        return '女'
      }
    },
    // 根据生日转化年龄
    birthday(val) {
      let nian = new Date().getYear()
      let nian1 = new Date(val * 1000).getYear()
      return (nian - nian1) + '岁'
    },
    // 转化地址
    address(val) {
      let arr = val.split('|')
      return arr[0]
    }
  },
  components: {
    footerBox
  }
}
</script>

<style scoped lang="scss">
.right-title {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .conten-btn-box {
    .conter-btn {
      height: 30px;
      padding: 0 15px;
    }
  }
}

.content-box {

  .box1 {
    display: flex;
    align-items: center;
    padding: 25px 50px;
    background: #fff;
    margin-bottom: 10px;

    .left {
      width: 126px;
      height: 156px;

      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }

    .right {
      padding-left: 20px;

      h1 {
        line-height: 56px;
        font-size: 36px;
        font-weight: normal;
      }

      p {
        line-height: 40px;

        span {
          padding: 0 10px;
        }
      }

      div {
        line-height: 40px;

        span {
          padding-right: 10px;

          i {
            position: relative;
            top: 1px;
            font-size: 18px;
            color: #00a2ea;
            padding-right: 5px;
          }
        }

      }
    }
  }

  .box2 {
    padding: 30px 20px;
    background: #fff;
    margin-bottom: 10px;

    .title {
      line-height: 44px;
      font-size: 22px;
    }

    .list {
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      div {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        width: 50%;
        line-height: 40px;

        span {
          display: block;
          min-width: 100px;
          color: #999;
        }

        b {
          padding: 0 30px 0 10px;
        }
      }
    }

    .items {
      padding: 40px 60px;
      position: relative;

      .time {
        color: #999;
        margin-bottom: 20px;
      }

      .list {
        padding-left: 40px;
      }

      .left-icon {
        position: absolute;
        top: 37px;
        left: 30px;
        width: 20px;
        height: 20px;
        background-color: #90d5f3;
        border-radius: 100%;

        i {
          position: absolute;
          top: 4px;
          left: 4px;
          width: 12px;
          height: 12px;
          background-color: #00a2ea;
          border-radius: 100%;
        }
      }

      .left-shu {
        position: absolute;
        top: 55px;
        left: 40px;
        width: 2px;
        height: 100%;
        background-color: #90d5f3;
      }
    }

    .items2 {
      padding: 28px 60px;

      .list {
        div {
          span {
            color: #333;
          }

          span.times {
            color: #999;
          }
        }
      }

    }
  }

  .box3 {
    position: absolute;
    top: 100px;
    right: -200px;
    width: 200px;
    padding: 20px;

    div {
      width: 100%;
      height: 40px;
      line-height: 40px;
      text-align: left;
      padding-left: 10px;
      margin-bottom: 10px;
      background: #fff;
      border: 1px solid #ddd;
      cursor: pointer;
    }
  }
}

.dialogBox {
  .title {
    font-size: 20px;
    text-align: center;
  }

  .list-lable {
    padding: 20px 0;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;

    .label-item {
      display: flex;
      align-items: center;
      margin: 0 20px 20px 0;

      span {
        display: block;
        padding: 5px 10px;
        color: #00a2ea;
        border: 1px solid #00a2ea;
      }

      b {
        padding: 0 5px;
        color: #00a2ea;
      }

      i {
        cursor: pointer;
      }
    }
  }

  .msbg-box {
    display: flex;
    align-items: center;
    padding: 20px 0;

    .ms-left {
      width: 50%;
      height: 400px;

      border-right: 1px solid #ddd;
      overflow-y: scroll;

      p {
        line-height: 38px;
        padding: 0 10px;
        border-bottom: 1px solid #ddd;

        &.active {
          background: #00a2ea;
          color: #fff;
        }
      }
    }

    .ms-left::-webkit-scrollbar {
      display: none;
    }

    .ms-right {
      width: 50%;
      height: 400px;
      padding: 0 10px;
      overflow-y: scroll;

      h3 {
        text-align: center;
        font-size: 16px;
        margin-bottom: 10px;
      }

      div {
        line-height: 24px;
      }
    }

    .ms-right::-webkit-scrollbar {
      display: none;
    }
  }
}

.add-label {
  display: flex;
  align-items: center;

  span {
    display: block;
    width: 120px;
  }

  .label-add-input {
    width: 250px;
    margin-right: 20px;
  }

  .add-label-btn {
    cursor: pointer;
  }
}
</style>
